import { useRouter } from "../lib/router-compat";
import { ReactNode } from "react";
import { openOverlay, setPendingOverlay } from "../lib/overlay-bus";

type Props = {
  to: string;
  label?: string;
  className?: string;
  activeClassName?: string;
  children: ReactNode;
  onClick?: () => void;
};

/** A Link that always opens the target page as an overlay on "/" — never changes route. */
export function OverlayLink({ to, label, className, children, onClick }: Props) {
  const router = useRouter();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick?.();
    const onHome = router.state.location.pathname === "/";
    if (!onHome) {
      setPendingOverlay({ path: to, label });
      router.navigate({ to: "/" });
    } else {
      openOverlay({ path: to, label });
    }
  };

  return (
    <a href={to} onClick={handleClick} className={className}>
      {children}
    </a>
  );
}
